module.exports = __webpack_public_path__ + "img/studyimg3.29025adb.jpg";